@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.dropdown-menu {
  max-width: none;
  width: 285px;
}

.dropdown-toggler-compact {
  padding: 0;
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid @color-picker--dropdown-toggler--border-color;

  &:hover {
    border-top-color: @color-picker--dropdown-toggler--hover--border-color;
  }
}

.dropdown-toggler-color {
  height: 30px;
  width: 30px;
  border-radius: 4px;
  margin: 5px 0;
}

.dropdown-toggler-color-compact {
  margin: 0;
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.colors-wrapper {
  padding: 10px;
  width: 100%;
  display: grid;
  grid-template-columns: 25px 25px 25px 25px 25px 25px 25px 25px 25px;
  grid-gap: 5px;
}

.color-button-wrapper {
  display: inline-block;
  position: relative;
  height: 25px;
  width: 25px;
  z-index: 1;

  &:hover {
    z-index: 2;
  }
}

.color-button {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 300ms ease;

  &.selected {
    border: 1px solid @color-picker--color-button--selected--border-color;
    box-shadow: 0 1px 2px 0 @color-picker--color-button--selected--box-shadow-color;
  }

  &.show-border {
    border: 1px solid @color-picker--color-button--show-border--border-color;
    &.selected {
      border: 1px solid @color-picker--color-button--show-border--selected--border-color;
    }
  }

  &:hover {
    top: -2px;
    left: -2px;
    height: 29px;
    width: 29px;
  }
}

.compact-icon-container {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;

  .compact-icon {
    height: 20px;
    width: 20px;
  }
}
